function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1940(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 28.85,
    height: 16.17,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.8510526315789475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 8.085,
    fontFamily: "Arial"
  }, "\n        Charles_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 16.17,
    width: 28.85,
    height: 19.36,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.21
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 25.85,
    fontFamily: "Arial"
  }, "\n        Buena_Vista_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 35.53,
    width: 28.85,
    height: 20.53,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.3686666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 45.795,
    fontFamily: "Arial"
  }, "\n        New_Kent_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 56.06,
    width: 28.85,
    height: 22.25,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.3088235294117647
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 67.185,
    fontFamily: "Arial"
  }, "\n        James_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 78.31,
    width: 28.85,
    height: 24.01,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.1433333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 90.315,
    fontFamily: "Arial"
  }, "\n        King_and_Queen_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 102.32,
    width: 28.85,
    height: 26.51,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5594117647058825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 115.57499999999999,
    fontFamily: "Arial"
  }, "\n        Williamsburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 128.83,
    width: 28.85,
    height: 27.39,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6111764705882354
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 142.525,
    fontFamily: "Arial"
  }, "\n        Cumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 156.22,
    width: 28.85,
    height: 31.61,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.2192307692307693
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 172.025,
    fontFamily: "Arial"
  }, "\n        Greene_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 187.83,
    width: 28.85,
    height: 32.78,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 204.22000000000003,
    fontFamily: "Arial"
  }, "\n        Powhatan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 220.61,
    width: 28.85,
    height: 33.47,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.6027777777777779
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 237.34500000000003,
    fontFamily: "Arial"
  }, "\n        King_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 254.08,
    width: 28.85,
    height: 33.96,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.404166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 271.06,
    fontFamily: "Arial"
  }, "\n        Essex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 288.04,
    width: 28.85,
    height: 34.94,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.803125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 305.51,
    fontFamily: "Arial"
  }, "\n        Middlesex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 322.98,
    width: 28.85,
    height: 36.31,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.9233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 341.135,
    fontFamily: "Arial"
  }, "\n        Richmond_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 359.29,
    width: 28.85,
    height: 38.12,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.404166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 378.35,
    fontFamily: "Arial"
  }, "\n        Surry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 397.41,
    width: 28.85,
    height: 39.99,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5184210526315791
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 417.40500000000003,
    fontFamily: "Arial"
  }, "\n        Rappahannock_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 437.4,
    width: 28.85,
    height: 40.23,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9233333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 457.515,
    fontFamily: "Arial"
  }, "\n        Fluvanna_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 477.63,
    width: 28.85,
    height: 40.72,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2192307692307693
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 497.99,
    fontFamily: "Arial"
  }, "\n        Amelia_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 518.35,
    width: 28.85,
    height: 44.25,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2192307692307693
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 540.475,
    fontFamily: "Arial"
  }, "\n        Sussex_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 562.6,
    width: 28.85,
    height: 45.33,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.4425000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 585.265,
    fontFamily: "Arial"
  }, "\n        Prince_George_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 607.92,
    width: 28.85,
    height: 45.67,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5184210526315791
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 630.755,
    fontFamily: "Arial"
  }, "\n        King_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 653.59,
    width: 28.85,
    height: 46.41,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.060714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.425,
    y: 676.7950000000001,
    fontFamily: "Arial"
  }, "\n        Mathews_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 0,
    width: 33.71,
    height: 40.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8091666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 45.705,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Craig_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62.56,
    y: 0,
    width: 34.52,
    height: 40.13,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1381818181818186
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 79.82000000000001,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        York_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 97.09,
    y: 0,
    width: 35.19,
    height: 40.13,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.9549999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 114.685,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Greensville_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 132.28,
    y: 0,
    width: 35.37,
    height: 40.13,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.210625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 149.965,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Goochland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 167.65,
    y: 0,
    width: 36.5,
    height: 40.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.28125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 185.9,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Lancaster_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.15,
    y: 0,
    width: 37.91,
    height: 40.13,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.106111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 223.10500000000002,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        South_Norfolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 242.06,
    y: 0,
    width: 38.82,
    height: 40.13,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.8485714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 261.47,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Northumberland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 280.88,
    y: 0,
    width: 39.56,
    height: 40.13,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.327058823529412
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 300.65999999999997,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Buckingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.44,
    y: 0,
    width: 40.65,
    height: 40.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1121052631578947
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 340.765,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Spotsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 361.1,
    y: 0,
    width: 40.97,
    height: 40.13,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.6481818181818184
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.58500000000004,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Bath_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 402.07,
    y: 0,
    width: 41.57,
    height: 40.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.360588235294118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 422.855,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Gloucester_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 443.64,
    y: 0,
    width: 41.64,
    height: 40.13,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.6753333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 464.46,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Highland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.28,
    y: 0,
    width: 42.06,
    height: 40.13,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3441666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 506.30999999999995,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Hampton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 527.34,
    y: 0,
    width: 42.38,
    height: 40.13,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.1121052631578947
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 548.5300000000001,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Westmoreland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.72,
    y: 0,
    width: 42.84,
    height: 40.13,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3441666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 591.14,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Radford_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 612.56,
    y: 0,
    width: 43.26,
    height: 40.13,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.229444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 634.1899999999999,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Northampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 655.82,
    y: 0,
    width: 44.18,
    height: 40.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.360588235294118
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 677.9100000000001,
    y: 20.065,
    fontFamily: "Arial"
  }, "\n        Martinsville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 40.13,
    width: 44.84,
    height: 40.01,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.667333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 60.135000000000005,
    fontFamily: "Arial"
  }, "\n        Stafford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 80.14,
    width: 44.84,
    height: 40.67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.1284615384615386
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 100.475,
    fontFamily: "Arial"
  }, "\n        Hopewell_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 120.81,
    width: 44.84,
    height: 42.31,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.0221428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 141.965,
    fontFamily: "Arial"
  }, "\n        Madison_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 163.12,
    width: 44.84,
    height: 42.44,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.122
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 184.34,
    fontFamily: "Arial"
  }, "\n        Isle_of_Wight_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 205.56,
    width: 44.84,
    height: 42.85,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.678125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 226.985,
    fontFamily: "Arial"
  }, "\n        Lunenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 248.41,
    width: 44.84,
    height: 42.97,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.527647058823529
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 269.895,
    fontFamily: "Arial"
  }, "\n        Appomattox_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 291.38,
    width: 44.84,
    height: 43.29,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.092142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 313.025,
    fontFamily: "Arial"
  }, "\n        Warwick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 334.67,
    width: 44.84,
    height: 43.51,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3469230769230767
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 356.425,
    fontFamily: "Arial"
  }, "\n        Clarke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 378.18,
    width: 44.84,
    height: 44.14,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.75875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 400.25,
    fontFamily: "Arial"
  }, "\n        Dinwiddie_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 422.32,
    width: 44.84,
    height: 45.24,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.242
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 444.94,
    fontFamily: "Arial"
  }, "\n        Prince_Edward_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 467.57,
    width: 44.84,
    height: 45.62,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9893333333333336
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 490.38,
    fontFamily: "Arial"
  }, "\n        Caroline_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 513.19,
    width: 44.84,
    height: 45.69,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.736666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 536.0350000000001,
    fontFamily: "Arial"
  }, "\n        Bland_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 558.88,
    width: 44.84,
    height: 45.91,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 581.835,
    fontFamily: "Arial"
  }, "\n        Brunswick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 604.78,
    width: 44.84,
    height: 46.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4492307692307693
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 628.145,
    fontFamily: "Arial"
  }, "\n        Louisa_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.85,
    y: 651.51,
    width: 44.84,
    height: 48.49,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.27,
    y: 675.755,
    fontFamily: "Arial"
  }, "\n        Nansemond_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.69,
    y: 40.13,
    width: 43.51,
    height: 50.14,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.417222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 95.445,
    y: 65.2,
    fontFamily: "Arial"
  }, "\n        Clifton_Forge_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.19,
    y: 40.13,
    width: 44.13,
    height: 50.14,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.3226315789473686
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 139.255,
    y: 65.2,
    fontFamily: "Arial"
  }, "\n        Fredericksburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 161.32,
    y: 40.13,
    width: 45.06,
    height: 50.14,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.7550000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 183.85,
    y: 65.2,
    fontFamily: "Arial"
  }, "\n        Suffolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 206.38,
    y: 40.13,
    width: 45.85,
    height: 50.14,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.526923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 229.305,
    y: 65.2,
    fontFamily: "Arial"
  }, "\n        Nelson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 252.22,
    y: 40.13,
    width: 47.2,
    height: 50.14,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.146666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 275.82,
    y: 65.2,
    fontFamily: "Arial"
  }, "\n        Nottoway_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.42,
    y: 40.13,
    width: 48.47,
    height: 50.14,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.462142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.65500000000003,
    y: 65.2,
    fontFamily: "Arial"
  }, "\n        Hanover_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 347.89,
    y: 40.13,
    width: 48.52,
    height: 50.14,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 372.15,
    y: 65.2,
    fontFamily: "Arial"
  }, "\n        Charlotte_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 396.42,
    y: 40.13,
    width: 48.86,
    height: 50.14,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.714444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 420.85,
    y: 65.2,
    fontFamily: "Arial"
  }, "\n        Southampton_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 445.28,
    y: 40.13,
    width: 49.17,
    height: 50.14,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7823076923076924
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 469.86499999999995,
    y: 65.2,
    fontFamily: "Arial"
  }, "\n        Staunton_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 494.45,
    y: 40.13,
    width: 49.6,
    height: 50.14,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8153846153846156
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 519.25,
    y: 65.2,
    fontFamily: "Arial"
  }, "\n        Orange_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 544.05,
    y: 40.13,
    width: 50.58,
    height: 50.14,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.3426666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 569.3399999999999,
    y: 65.2,
    fontFamily: "Arial"
  }, "\n        Culpeper_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 594.63,
    y: 40.13,
    width: 51.68,
    height: 50.14,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.856923076923077
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 620.47,
    y: 65.2,
    fontFamily: "Arial"
  }, "\n        Warren_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 646.32,
    y: 40.13,
    width: 53.68,
    height: 50.14,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.178333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 673.1600000000001,
    y: 65.2,
    fontFamily: "Arial"
  }, "\n        Bristol_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.69,
    y: 90.27,
    width: 57.12,
    height: 48.01,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.286190476190476
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.25,
    y: 114.27499999999999,
    fontFamily: "Arial"
  }, "\n        Prince_William_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.69,
    y: 138.28,
    width: 57.12,
    height: 49.47,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.5335714285714284
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.25,
    y: 163.015,
    fontFamily: "Arial"
  }, "\n        Patrick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.69,
    y: 187.76,
    width: 57.12,
    height: 51.16,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4106666666666663
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.25,
    y: 213.33999999999997,
    fontFamily: "Arial"
  }, "\n        Winchester_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.69,
    y: 238.91,
    width: 57.12,
    height: 52.89,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.6445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.25,
    y: 265.355,
    fontFamily: "Arial"
  }, "\n        Princess_Anne_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.69,
    y: 291.8,
    width: 57.12,
    height: 54.8,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.25,
    y: 319.2,
    fontFamily: "Arial"
  }, "\n        Floyd_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.69,
    y: 346.6,
    width: 57.12,
    height: 56.43,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.7025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.25,
    y: 374.815,
    fontFamily: "Arial"
  }, "\n        Henry_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.69,
    y: 403.03,
    width: 57.12,
    height: 58.09,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.25,
    y: 432.075,
    fontFamily: "Arial"
  }, "\n        Amherst_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.69,
    y: 461.12,
    width: 57.12,
    height: 58.56,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.808
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.25,
    y: 490.4,
    fontFamily: "Arial"
  }, "\n        Accomack_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.69,
    y: 519.67,
    width: 57.12,
    height: 59.55,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.25,
    y: 549.4449999999999,
    fontFamily: "Arial"
  }, "\n        Frederick_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.69,
    y: 579.22,
    width: 57.12,
    height: 59.94,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.25,
    y: 609.19,
    fontFamily: "Arial"
  }, "\n        Botetourt_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.69,
    y: 639.17,
    width: 57.12,
    height: 60.83,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.25,
    y: 669.5849999999999,
    fontFamily: "Arial"
  }, "\n        Albemarle_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.81,
    y: 90.27,
    width: 58.29,
    height: 60.17,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4288235294117646
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 159.955,
    y: 120.35499999999999,
    fontFamily: "Arial"
  }, "\n        Harrisonburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.1,
    y: 90.27,
    width: 59.09,
    height: 60.17,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.9545000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.64499999999998,
    y: 120.35499999999999,
    fontFamily: "Arial"
  }, "\n        Charlottesville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.18,
    y: 90.27,
    width: 59.56,
    height: 60.17,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.5035294117647062
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 277.96000000000004,
    y: 120.35499999999999,
    fontFamily: "Arial"
  }, "\n        Rockbridge_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 307.74,
    y: 90.27,
    width: 61.95,
    height: 60.17,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.011333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 338.71500000000003,
    y: 120.35499999999999,
    fontFamily: "Arial"
  }, "\n        Fauquier_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 369.7,
    y: 90.27,
    width: 63.74,
    height: 60.17,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.342777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 401.57,
    y: 120.35499999999999,
    fontFamily: "Arial"
  }, "\n        Mecklenburg_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 433.44,
    y: 90.27,
    width: 64.47,
    height: 60.17,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.014166666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 465.675,
    y: 120.35499999999999,
    fontFamily: "Arial"
  }, "\n        Giles_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.9,
    y: 90.27,
    width: 66.14,
    height: 60.17,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.011333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 530.97,
    y: 120.35499999999999,
    fontFamily: "Arial"
  }, "\n        Petersburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 564.04,
    y: 90.27,
    width: 66.23,
    height: 60.17,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.011333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 597.155,
    y: 120.35499999999999,
    fontFamily: "Arial"
  }, "\n        Campbell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 630.27,
    y: 90.27,
    width: 69.73,
    height: 60.17,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.011333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.135,
    y: 120.35499999999999,
    fontFamily: "Arial"
  }, "\n        Franklin_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.81,
    y: 150.44,
    width: 66.86,
    height: 63.43,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.0204761904761903
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.24,
    y: 182.155,
    fontFamily: "Arial"
  }, "\n        Elizabeth_City_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.81,
    y: 213.87,
    width: 66.86,
    height: 67.97,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.571666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.24,
    y: 247.85500000000002,
    fontFamily: "Arial"
  }, "\n        Wythe_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.81,
    y: 281.84,
    width: 66.86,
    height: 68.31,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.775714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.24,
    y: 315.995,
    fontFamily: "Arial"
  }, "\n        Loudoun_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.81,
    y: 350.15,
    width: 66.86,
    height: 68.44,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.078181818181818
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.24,
    y: 384.37,
    fontFamily: "Arial"
  }, "\n        Page_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.81,
    y: 418.59,
    width: 66.86,
    height: 68.82,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.775714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.24,
    y: 453,
    fontFamily: "Arial"
  }, "\n        Pulaski_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.81,
    y: 487.41,
    width: 66.86,
    height: 70.38,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.17875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.24,
    y: 522.6,
    fontFamily: "Arial"
  }, "\n        Alleghany_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.81,
    y: 557.79,
    width: 66.86,
    height: 70.62,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.775714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.24,
    y: 593.0999999999999,
    fontFamily: "Arial"
  }, "\n        Bedford_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.81,
    y: 628.41,
    width: 66.86,
    height: 71.59,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.775714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 164.24,
    y: 664.2049999999999,
    fontFamily: "Arial"
  }, "\n        Carroll_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.67,
    y: 150.44,
    width: 66.39,
    height: 81.47,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.742142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 230.86499999999998,
    y: 191.175,
    fontFamily: "Arial"
  }, "\n        Halifax_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 264.06,
    y: 150.44,
    width: 66.77,
    height: 81.47,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.451333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 297.445,
    y: 191.175,
    fontFamily: "Arial"
  }, "\n        Buchanan_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.83,
    y: 150.44,
    width: 70.71,
    height: 81.47,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.159411764705882
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 366.185,
    y: 191.175,
    fontFamily: "Arial"
  }, "\n        Montgomery_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.54,
    y: 150.44,
    width: 71.86,
    height: 81.47,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.527692307692307
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 437.47,
    y: 191.175,
    fontFamily: "Arial"
  }, "\n        Danville_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.4,
    y: 150.44,
    width: 73.94,
    height: 81.47,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.891578947368421
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 510.37,
    y: 191.175,
    fontFamily: "Arial"
  }, "\n        Chesterfield_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.34,
    y: 150.44,
    width: 75.36,
    height: 81.47,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.71
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 585.02,
    y: 191.175,
    fontFamily: "Arial"
  }, "\n        Dickenson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 622.7,
    y: 150.44,
    width: 77.3,
    height: 81.47,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.068421052631579
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 661.35,
    y: 191.175,
    fontFamily: "Arial"
  }, "\n        Pittsylvania_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.67,
    y: 231.91,
    width: 87.8,
    height: 72.05,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.146428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.57,
    y: 267.935,
    fontFamily: "Arial"
  }, "\n        Norfolk_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.67,
    y: 303.96,
    width: 87.8,
    height: 73.49,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.249285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.57,
    y: 340.705,
    fontFamily: "Arial"
  }, "\n        Augusta_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.67,
    y: 377.45,
    width: 87.8,
    height: 73.58,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.131666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.57,
    y: 414.24,
    fontFamily: "Arial"
  }, "\n        Smyth_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.67,
    y: 451.03,
    width: 87.8,
    height: 77.27,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5452941176470585
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.57,
    y: 489.66499999999996,
    fontFamily: "Arial"
  }, "\n        Newport_News_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.67,
    y: 528.3,
    width: 87.8,
    height: 83.73,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.980714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.57,
    y: 570.165,
    fontFamily: "Arial"
  }, "\n        Russell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 197.67,
    y: 612.02,
    width: 87.8,
    height: 87.98,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.316666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.57,
    y: 656.01,
    fontFamily: "Arial"
  }, "\n        Scott_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.47,
    y: 231.91,
    width: 81.14,
    height: 95.34,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.4093333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.04,
    y: 279.58,
    fontFamily: "Arial"
  }, "\n        Tazewell_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.62,
    y: 231.91,
    width: 81.94,
    height: 95.34,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.852857142857142
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.59000000000003,
    y: 279.58,
    fontFamily: "Arial"
  }, "\n        Grayson_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.56,
    y: 231.91,
    width: 82.21,
    height: 95.34,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.8358823529411765
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 489.665,
    y: 279.58,
    fontFamily: "Arial"
  }, "\n        Rockingham_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 530.76,
    y: 231.91,
    width: 83.93,
    height: 95.34,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.995
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 572.725,
    y: 279.58,
    fontFamily: "Arial"
  }, "\n        Fairfax_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 614.69,
    y: 231.91,
    width: 85.31,
    height: 95.34,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.687333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 657.345,
    y: 279.58,
    fontFamily: "Arial"
  }, "\n        Portsmouth_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.47,
    y: 327.25,
    width: 89.83,
    height: 91.76,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.988666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.38500000000005,
    y: 373.13,
    fontFamily: "Arial"
  }, "\n        Alexandria_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.47,
    y: 419.01,
    width: 89.83,
    height: 92.66,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.416428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.38500000000005,
    y: 465.34,
    fontFamily: "Arial"
  }, "\n        Roanoke_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.47,
    y: 511.67,
    width: 89.83,
    height: 94.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.284117647058824
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.38500000000005,
    y: 558.695,
    fontFamily: "Arial"
  }, "\n        Washington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.47,
    y: 605.72,
    width: 89.83,
    height: 94.28,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.284117647058824
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 330.38500000000005,
    y: 652.86,
    fontFamily: "Arial"
  }, "\n        Shenandoah_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.31,
    y: 327.25,
    width: 104.39,
    height: 81.23,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.384545454545455
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 427.505,
    y: 367.865,
    fontFamily: "Arial"
  }, "\n        Wise_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.7,
    y: 327.25,
    width: 104.9,
    height: 81.23,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.802142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 532.15,
    y: 367.865,
    fontFamily: "Arial"
  }, "\n        Henrico_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 584.59,
    y: 327.25,
    width: 115.41,
    height: 81.23,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.802142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 642.2950000000001,
    y: 367.865,
    fontFamily: "Arial"
  }, "\n        Lynchburg_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.31,
    y: 408.48,
    width: 131.97,
    height: 72.94,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.294
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.295,
    y: 444.95000000000005,
    fontFamily: "Arial"
  }, "\n        Lee_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.31,
    y: 481.42,
    width: 131.97,
    height: 105.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.603125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.295,
    y: 534.245,
    fontFamily: "Arial"
  }, "\n        Arlington_County\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375.31,
    y: 587.07,
    width: 131.97,
    height: 112.93,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.410833333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 441.295,
    y: 643.5350000000001,
    fontFamily: "Arial"
  }, "\n        Roanoke_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.27,
    y: 408.48,
    width: 192.73,
    height: 104.92,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.743333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.635,
    y: 460.94,
    fontFamily: "Arial"
  }, "\n        Norfolk_City\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 507.27,
    y: 513.4,
    width: 192.73,
    height: 186.6,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.353846153846153
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.635,
    y: 606.6999999999999,
    fontFamily: "Arial"
  }, "\n        Richmond_City\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1940);
export default __webpack_public_path__ + "static/media/1940.6d8ba29a29c47c22d7c177ded77db675.svg";
export { ForwardRef as ReactComponent };